<template>
    <label class="ak-form__checkbox">
    <input
            type="checkbox"
            v-model="currentValue"
            @change="valueChanged"
    />
        <span class="ak-form__checkmark ak-form__checkmark--checkbox"></span>
    </label>
</template>

<script>

export default {
    name: 'ak-ignore-check',
    data() {
        return {
            currentValue: false
        }
    },
    props: {
        id: {
            type: String
        },
        value: {
            type: Boolean
        },
    },
    methods: {
        valueChanged() {
            this.$emit('change', this.currentValue);
        },
    },
    mounted() {
        this.currentValue = this.value;
    }
}
</script>
